module.exports = __webpack_public_path__ + "img/robbedRedEnvelopesImage.25625445.png";